import { Appbar } from "react-native-paper";
import useModalHeaderHeight from "../../hooks/useModalHeaderHeight";

type Props = {
	headerTitle?: string;
	backIcon?: string;
	headerRight?: () => React.ReactNode;
	onBack: () => void;
};

const ModalHeader = ({ headerTitle, backIcon, headerRight, onBack }: Props) => {
	const statusBarHeight = useModalHeaderHeight();
	return (
		<Appbar.Header
			statusBarHeight={statusBarHeight}
			mode="center-aligned"
			elevated
		>
			<Appbar.Action onPress={onBack} icon={backIcon || "close"} />
			<Appbar.Content title={headerTitle || ""} />
			{headerRight?.()}
		</Appbar.Header>
	);
};

export default ModalHeader;
